import { render, staticRenderFns } from "./GaleriaColorProductComponent.vue?vue&type=template&id=e497207c&scoped=true"
import script from "./GaleriaColorProductComponent.vue?vue&type=script&lang=js"
export * from "./GaleriaColorProductComponent.vue?vue&type=script&lang=js"
import style0 from "./GaleriaColorProductComponent.vue?vue&type=style&index=0&id=e497207c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e497207c",
  null
  
)

export default component.exports